export const ENABLE_DEV_TOOLS = process.env.NODE_ENV_STRING === 'development'

/* Internet Explorer 6-11 */
export const isIE = false || !!document.documentMode
/* Edge 20+ */
export const isEdge = !isIE && !!window.StyleMedia

export const TABLET_BREAKPOINT = 640



// WEBPACK FOOTER //
// ./globals/constants.js